const date = new Date();
const dateBeginArchive = new Date();
const dateEndForecast = new Date();

const hour = formateHour(date.getHours());

dateBeginArchive.setDate(dateBeginArchive.getDate() - 3);
dateEndForecast.setDate(dateEndForecast.getDate() + 3);

const timeEnd = formatDate(date);
const timeEndForecast = formatDate(dateEndForecast);
const timeBegin = formatDate(dateBeginArchive);
const timeBeginForecast = formatDate(date);

function formatDate(date) {
  let dd = date.getDate();
  if (dd < 10) dd = "0" + dd;

  let mm = date.getMonth() + 1;
  if (mm < 10) mm = "0" + mm;

  let yy = date.getFullYear();
  if (yy < 10) yy = "0" + yy;

  return yy + "-" + mm + "-" + dd;
}

function formateHour(hour) {
  if (hour < 10) hour = "0" + hour;
  return hour;
}

/* Преобразование даты в текст для карточки */
function DateToText(e) {
  if (e != undefined) {
    const date = e.split(" ")[0].split("-");
    const hour = e.split(" ")[1].split(":");
    const result = new Date(date[0], date[1] - 1, date[2], hour[0], hour[1], 0).toLocaleString("ru", {
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    });
    return result;
  } else {
    return new Date().toLocaleString("ru", {
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    });
  }
}

export { formatDate, formateHour, DateToText, dateBeginArchive, dateEndForecast, hour, timeEnd, timeEndForecast, timeBegin, timeBeginForecast };
